// @ts-nocheck
import getColor from "@insite/mobius/utilities/getColor";
import Styleguide from "@toolkit/Framework/Types/Styleguide";
import ChevronDown from "@toolkit/Library/Components/Icons/ChevronDown";
import { css } from "styled-components";

const select: Styleguide["select"] = {
    defaultProps: {
        iconProps: { src: ChevronDown },
        css: css`
            &&[data-selected-index=""] {
                color: ${getColor("placeholder")};

                &:disabled,
                &.disabled {
                    color: ${getColor("placeholder.disabled")};
                }
            }

            option {
                color: ${getColor("text.input")};

                &[value=""] {
                    color: ${getColor("placeholder")};
                }

                &:disabled {
                    background-color: ${x => getColor("common.disabled")};
                    color: ${getColor("text.disabled")};
                }
            }
        `,
    },
};

export default select;
